export function TimestampStringToDateString(timestampString: string) {
  const timestamp = new Date(timestampString).valueOf();
  const date = new Date(timestamp);
  const dateString = `${date.getDay()}/${date.getMonth()}/${date.getFullYear()}`;

  return dateString;
}
